import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {MainComponent} from './components/main/main.component';
import {LoginComponent} from './components/login/login.component';
import {TechSupportComponent} from './components/tech-support/tech-support.component';
import {CollegeInfoComponent} from './components/college-info/college-info.component';
import {CommonMainLayoutComponent} from './components/common-main-layout/common-main-layout.component';
import {MenuItemComponent} from '../../common/directives/menu/menu-item/menu-item.component';
import {RegisterGraduatesComponent} from './components/register/register-graduates/register-graduates.component';
import {NewsComponent} from '../user/components/news/news.component';
import {PageLayoutComponent} from './components/page-layout/page-layout.component';
import {RestorePasswordComponent} from './components/restore-password/restore-password.component';
import {NewsLayoutComponent} from './components/news-layout/news-layout.component';
import {UserConfirmationComponent} from './components/user-confirmation/user-confirmation.component';
import {SearchPagesNewsComponent} from './components/search-pages-news/search-pages-news.component';
import {EnrollEnterComponent} from './components/enroll-enter/enroll-enter.component';
import {EnrollExamResultsComponent} from './components/enroll-exam-results/enroll-exam-results.component';
import {ApplyGovServicesComponent} from './components/apply-gov-services/apply-gov-services.component';
import {ModuleENUM} from '../../common/enums/module.enum';
import {RegionCollegesProfessionsComponent} from '../user/components/data/region-colleges-professions/region-colleges-professions.component';
import {PublicEnrollsListComponent} from './components/public-enrolls-list/public-enrolls-list.component';
import {PublicApplicantsListComponent} from './components/public-applicants-list/public-applicants-list.component';

const routes: Routes = [{
  path: '',
  component: CommonMainLayoutComponent,
  children: [
    {
      path: '',
      component: MainComponent
    },
    {
      path: 'news',
      component: NewsComponent,
    },
    {
      path: 'news/tag/:tagId',
      component: NewsComponent
    },
    {
      path: 'news/:newsId',
      component: NewsLayoutComponent
    },
    {
      path: 'college-info',
      component: CollegeInfoComponent
    },
    {
      path: 'login',
      component: LoginComponent
    },
    {
      path: 'user-confirmation/:id',
      component: UserConfirmationComponent
    },
    {
      path: 'tech-support',
      component: TechSupportComponent
    },
    {
      path: 'register/graduates',
      component: RegisterGraduatesComponent
    },
    {
      path: 'page/:pageId',
      component: PageLayoutComponent
    },
    {
      path: 'restore/:id',
      component: RestorePasswordComponent
    },
    {
      path: 'search/:text',
      component: SearchPagesNewsComponent
    },
    {
      path: 'enroll/login',
      component: EnrollEnterComponent
    },
    {
      path: 'region-professions',
      component: RegionCollegesProfessionsComponent,
    },
    {
      path: 'enroll/exam/results',
      component: EnrollExamResultsComponent
    },
    {
      path: 'apply/gov-services',
      component: ApplyGovServicesComponent,
      data: {module: ModuleENUM.PUBLIC_SERVICES},
    },
    {
      path: 'region-enrolls',
      component: PublicEnrollsListComponent,
    },
    {
      path: 'region-applicants',
      component: PublicApplicantsListComponent,
    },
  ]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CommonMainRoutingModule {
}

export const routedCommonMainComponents = [
  CommonMainLayoutComponent,
  MainComponent,
  CollegeInfoComponent,
  LoginComponent,
  TechSupportComponent,
  MenuItemComponent,
  RegisterGraduatesComponent,
  RestorePasswordComponent,
  UserConfirmationComponent,
  EnrollEnterComponent,
  EnrollExamResultsComponent,
  RegionCollegesProfessionsComponent,
  PublicEnrollsListComponent,
  PublicApplicantsListComponent,
];



// WEBPACK FOOTER //
// ./src/app/modules/common-main/common-main-routing.module.ts